import createAnimationWrapper from "./createAnimationWrapper";

const move = ({x=0,y=0}) => ({
  "0%": { transform: "translate(0,0)" },
  "100%": { transform: `translate(${x}, ${y})` }
});

const Move = createAnimationWrapper(move, {
  duration: "1s",
});

const MoveTo = ({to={}, ...props}) => <Move animation={move(to)} {...props} />;

export default MoveTo;
